import { useParams } from 'react-router-dom'
import EditSourceForm from './EditSourceForm'
import { useGetSourcesQuery } from './sourcesApiSlice'
import { useGetCountriesQuery } from '../countries/countriesApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditSource = () => {
    useTitle('ORACLY: Edit Source')

    const { id } = useParams()

    const { countryname, isManager, isAdmin } = useAuth()

    const { Source } = useGetSourcesQuery("sourcesList", {
        selectFromResult: ({ data }) => ({
            Source: data?.entities[id]
        }),
    })

    if (!Source) return <PulseLoader color={"#FFF"} />


    if (!isManager && !isAdmin) {
        if (Source.countryname !== countryname) {
            return <p className="errmsg">No access</p>
        }
    }

    const content = <EditSourceForm Source={Source} />

    return content
}
export default EditSource